import { monthSort } from "./constant";

export const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, "0")}/${String(
    d.getMonth() + 1
  ).padStart(2, "0")}/${String(d.getFullYear())}`;
};

export const formatReportingDateGhgEntry = (value) => {
  if (value == null || value === "") return "";
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, "0");
    const d = String(value.getDate()).padStart(2, "0");
    return `${d}/${m}/${y}`;
  }
  const raw = String(value).trim();
  if (!raw) return "";
  const datePart = raw.includes("T") ? raw.split("T")[0] : raw;
  const [year, month, day] = datePart.split("-");
  if (!year || !month || !day) return formatDate(value);
  return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;
};

export const formatDateToDDMMYYYY = (dateValue) => {
  if (!dateValue) return "-";

  const rawDate = String(dateValue).trim();
  if (!rawDate) return "-";

  // Keep already formatted dd-mm-yyyy values as-is.
  if (/^\d{2}-\d{2}-\d{4}$/.test(rawDate)) {
    return rawDate;
  }

  const normalizedDate = rawDate.includes("T")
    ? rawDate.split("T")[0]
    : rawDate;
  const date = new Date(normalizedDate);

  if (Number.isNaN(date.getTime())) {
    return rawDate;
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const generateMonthArray = (from, to) => {
  let months = [];
  let { month: startMonth, year: startYear } = from;
  let { month: endMonth, year: endYear } = to;

  while (
    startYear < endYear ||
    (startYear === endYear && startMonth <= endMonth)
  ) {
    months.push(
      `${monthSort[startMonth - 1]}'${startYear.toString().slice(-2)}`
    );

    startMonth++;
    if (startMonth > 12) {
      startMonth = 1;
      startYear++;
    }
  }

  return months;
};

export const getMonthCount = (fromDate, toDate) => {
  return (
    (toDate.year - fromDate.year) * 12 + (toDate.month - fromDate.month) + 1
  );
};

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatDateMonth = (date) => {
  if (!date) return "-";

  const dateObj = new Date(date);
  if (Number.isNaN(dateObj.getTime())) {
    return String(date).trim() || "-";
  }

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = MONTH_LABELS[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day} ${month} ${year}`;
};

/** Reporting period dates (Franchise/Investment view): use ISO date part, not local timezone */
export const formatReportingDateMonth = (date) => {
  if (!date) return "-";

  const raw = String(date).trim();
  const datePart = raw.includes("T") ? raw.split("T")[0] : raw.split(" ")[0];
  const isoMatch = datePart.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const monthIndex = Number(isoMatch[2]) - 1;
    const day = Number(isoMatch[3]);
    if (
      monthIndex >= 0 &&
      monthIndex < 12 &&
      day >= 1 &&
      day <= 31 &&
      Number.isFinite(year)
    ) {
      return `${String(day).padStart(2, "0")} ${MONTH_LABELS[monthIndex]} ${year}`;
    }
  }

  return formatDateMonth(date);
};
